var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccepted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#4FEBD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.231 7.40711C16.5157 7.0053 16.4207 6.44881 16.0189 6.16415C15.6171 5.87949 15.0606 5.97445 14.7759 6.37627L9.10491 14.3812L6.52209 11.7983C6.17389 11.4501 5.60935 11.4501 5.26115 11.7983C4.91295 12.1465 4.91295 12.7111 5.26115 13.0593L8.50593 16.3041C8.67207 16.4702 8.88746 16.5571 9.1051 16.5647C9.43723 16.6275 9.7908 16.4978 9.99898 16.2039L16.231 7.40711Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccepted);
export default __webpack_public_path__ + "static/media/accepted.51e2870c.svg";
export { ForwardRef as ReactComponent };